type MediaSize = 'thumbnail' | 'card' | 'hero'

export function getMediaUrl(media: any, size?: MediaSize) {
  if (!media) return null
  if (typeof media === 'string') return media

  // In local development, serve files from the local public/media directory
  // since seeded assets are stored locally and not uploaded to R2 bucket.
  if (process.env.NODE_ENV !== 'production') {
    if (size && media.sizes?.[size]?.filename) {
      return `/media/${media.sizes[size].filename}`
    }
    if (media.filename) {
      return `/media/${media.filename}`
    }
  }

  return (size && media.sizes?.[size]?.url) || media.url || null
}

